<template>
  <div class="watch-list-card">
    <div class="watch-list-card__top">
      <div class="watch-list-card__title">
        {{ title }}
      </div>
      <div class="watch-list-card__actions">
        <nuxt-link class="view-card"  :to="viewLink()">View</nuxt-link>
        <div class="edit-card" @click="editable = true">Edit</div>
        <div class="dell-card" @click="deleteItem">Delete</div>
        <div class="alerts-type">
          <el-select v-model="alertType" placeholder="" @change="itemSaved">
            <el-option
              v-for="item in alertTypeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </div>
      </div>
    </div>

    <!-- <div v-if="tags" class="article__tags">
      <Tag
        v-for="(tag, index) in tags.filter((item, index) => index < 3)"
        :key="index"
        :text="tag.key"
        :color="'red'"
        :link="tag.view_taxonomy_term"
        :uuid="tag.uuid"
        :tid="tag.tid"
      />
    </div> -->

    <div v-if="editable" class="watch-list-card__bottom">
      <div class="watch-list-card__edit-name">
        <input v-model="editName" type="text" />
        <div class="save" @click="itemSaved">Save</div>
      </div>
      <div class="cancel" @click="editable = false">Cancel</div>
    </div>
  </div>
</template>

<script>
// import config from "../../nuxt.config";
export default {
  name: "WatchListCard",
  components: {
    // Tag: () => import("../elements/Tag"),
  },
  props: {
    tags: {
      type: [Array, String],
      default: null,
    },
    title: {
      type: String,
      default: null,
    },
    id: {
      type: Number,
      default: null,
    },
    alerts: {
      type: String,
      default: null,
    },
    type: {
      type: String,
      default: null,
    },
  },
  data: () => ({
    editName: "",
    alertType: "daily",
    editable: false,
    alertTypeOptions: [
      {
        value: "daily",
        label: "Immediate alerts",
      },
      {
        value: "weekly",
        label: "Weekly alerts",
      },
      {
        value: "monthly",
        label: "Monthly alerts",
      },
      {
        value: "none",
        label: "No alerts",
      },
    ],
  }),
  computed: {},
  watch: {},
  mounted() {
    this.alertType = this.alerts;
  },
  methods: {
    deleteItem() {
      const method = "DELETE";
      this.$axios({
        method,
        url: `${this.$config.apiURL}/watchlist/${this.id}`,
      })
        .then((data) => {
          this.$emit("updateWatchList");
        })
        .catch((error) => {
          this.loadingData = true;
          console.error(error);
        });
    },
    itemSaved() {
      const method = "PATCH";
      this.editable = false;
      let name = this.title;

      if (this.editName) {
        name = this.editName;
      }

      const data = {
        name,
        emailPreferences: this.alertType,
        tags: this.tags,
        type: this.type,
      };
      this.$axios({
        method,
        url: `${this.$config.apiURL}/watchlist/${this.id}`,
        data,
      })
        .then((data) => {
          this.$emit("updateWatchList");
        })
        .catch((error) => {
          this.loadingData = true;
          console.error(error);
        });
    },
    viewLink() {
      const routeTypeMapping = {
        "guides": "world",
        "requirements": "requirement",
        "horizon_scanning": "regulatory_updates",
        "all": "search"
      };
      const baseRoute = routeTypeMapping[this.type] ?? this.type;
      const link = `/${baseRoute}`;

      if (this.tags && this.tags.length > 0) {
        const typeCounts = new Map();
        this.tags.forEach(tag => {
          if(typeCounts.has(tag.type)) {
            typeCounts.set(tag.type, typeCounts.get(tag.type) + 1);
          } else {
            typeCounts.set(tag.type, 1);
          }
        });
        // For some annoying reasons, we need the extra [] for the singular one's as for one it'll be registered as query.theParam == number and for those with multiple query.theParam == [number]
        const filterString = this.tags.map(tag => {
          if(typeCounts.get(tag.type) > 1) {
            return `filter[${tag.type}]=${tag.tid}`;
          } else {
            return `filter[${tag.type}][]=${tag.tid}`;
          }
        }).join("&");
        return `${link}?${filterString}`;
      }

      return link;
    }
  },
};
</script>

<style lang="scss">
@import "../../assets/styles/helpers/variables";
@import "../../assets/styles/helpers/mixin";
.watch-list-card {
  margin-bottom: 5rem;
  position: relative;

  &__top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px dashed $border;
    margin-bottom: 1rem;
  }

  &__actions {
    display: flex;
    align-items: center;
    font-size: 1.2rem;

    .view-card {
      cursor: pointer;
      margin-right: 2rem;
      color: $corporateBlue;
      text-decoration: none;
    }

    .edit-card {
      cursor: pointer;
    }

    .dell-card {
      color: $red;
      margin: 0 2rem;
      cursor: pointer;
    }

    .alerts-type {
      height: 2rem;

      .el-select,
      .el-input {
        height: 100%;
      }

      .el-input__suffix {
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .el-input--suffix .el-input__inner {
        height: 100%;
        font-size: 1.2rem;
        border: 1px solid #c6d5e0;
        width: 14rem;
        padding-left: 1rem;
        display: block;
      }
    }
  }

  &__bottom {
    display: flex;
    align-items: center;

    .cancel {
      margin-left: 3rem;
      flex-shrink: 0;
      font-size: 1.2rem;
      cursor: pointer;
    }
  }

  &__edit-name {
    width: 100%;
    position: relative;
    display: flex;
    align-items: center;
    cursor: pointer;

    input {
      border: 1px solid #c6d5e0;
      width: 100%;
      display: block;
      padding: 0 8rem 0 2rem;
      height: 4rem;
    }

    .save {
      position: absolute;
      right: 1rem;
      background: $red;
      display: flex;
      align-items: center;
      justify-content: center;
      color: $white;
      font-weight: 700;
      font-size: 1.4rem;
      width: 6rem;
      height: 3rem;
    }
  }

  .article__tags {
    border-bottom: none;

    &-more {
      margin-left: 1rem;
      font-weight: 600;
    }
  }
}
</style>
